/*
 * Herzwarm FAQ (sections/hw-faq.liquid): Sprunglink auf eine einzelne Frage öffnet das
 * <details> und scrollt hin. IDs sind section-scoped (frage-<section.id>-<frage>); ältere
 * Links der Form #frage-<frage> werden weiterhin aufgelöst (erste passende Frage).
 * Wird einmal pro Seite über snippets/hw-styles.liquid geladen (defer).
 */
(() => {
  const oeffnen = () => {
    if (!location.hash) return;
    let id;
    try {
      id = decodeURIComponent(location.hash.slice(1));
    } catch (e) {
      return; // ungültige Prozent-Kodierung im Hash
    }
    if (!id.startsWith('frage-')) return;
    let el = document.getElementById(id);
    if (!el && window.CSS && CSS.escape) {
      el = document.querySelector(`details[id^="frage-"][id$="-${CSS.escape(id.slice(6))}"]`);
    }
    if (el && el.tagName === 'DETAILS') {
      el.open = true;
      el.scrollIntoView({ block: 'start' });
    }
  };
  window.addEventListener('hashchange', oeffnen);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', oeffnen);
  else oeffnen();
})();
